import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import { Link } from "react-router-dom";
import { getImageUrl } from "../../Service/Service";
import PriceDisplay from "../PriceDisplay";

const HolidayPackageCard = ({ packageData, rating = 3 }) => {
  const getPackageImages = (pkg) => {
    const images = [];
    for (let i = 1; i <= 10; i++) {
      const imgKey = `makkah_img${i}`;
      const imgValue = pkg[imgKey];
      if (imgValue && typeof imgValue === 'string' && imgValue.trim() !== '') {
        images.push(imgValue);
      }
    }
    for (let i = 1; i <= 10; i++) {
      const imgKey = `madina_img${i}`;
      const imgValue = pkg[imgKey];
      if (imgValue && typeof imgValue === 'string' && imgValue.trim() !== '') {
        images.push(imgValue);
      }
    }
    return [...new Set(images)];
  };

  const packageImages = getPackageImages(packageData);
  const displayImages = packageImages.length > 0 ? packageImages : (packageData.makkah_img1 ? [packageData.makkah_img1] : []);

  const startLabel = 'Holidays in Best Price';

  const stars = Math.min(5, Math.max(1, Number(rating) || 3));

  return (
    <Link
      to={`/packagedetail?package=${packageData.uid}`}
      className="group block bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300"
    >
      {/* Image */}
      {displayImages.length > 0 ? (
        <div className="relative w-full h-52 md:h-56 overflow-hidden">
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            modules={[Autoplay]}
            className="h-full w-full"
          >
            {displayImages.map((img, imgIndex) => (
              <SwiperSlide key={imgIndex}>
                <img
                  src={getImageUrl(img)}
                  alt={`${packageData.name} - ${imgIndex + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className="w-full h-52 md:h-56 bg-gray-100 flex items-center justify-center">
          <span className="text-gray-400 text-sm">No image</span>
        </div>
      )}

      {/* Title in red strip (like deal cards) */}
      <div className="bg-gradient-to-r from-secondary to-navy-800 p-4 text-white">
        <h3 className="text-xl md:text-2xl font-extrabold tracking-tight text-left truncate">
          {packageData.name}
        </h3>
      </div>

      {/* Content */}
      <div className="p-4 md:p-5">
        <p className="text-sm text-gray-500 mb-2">
          {startLabel}
        </p>
        {/* Star rating */}
        <div className="rating rating-sm gap-0.5 mb-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <input
              key={i}
              type="radio"
              name={`rating-holiday-${packageData.uid}`}
              className="mask mask-star-2 bg-amber-400"
              checked={i === stars}
              readOnly
              onChange={() => {}}
            />
          ))}
        </div>
        <div className="flex items-baseline gap-1">
          <PriceDisplay
            amount={packageData.price}
            displayCurrency="GBP"
            className="text-2xl md:text-3xl font-bold text-secondary"
          />
          <span className="text-sm text-gray-500">per person</span>
        </div>
      </div>
    </Link>
  );
};

export default HolidayPackageCard;
